<template>
  <v-card class="rounded-xl" :border="false" :elevation="0">
    <v-row>
      <!--STATUS LIST AT LEFT-->
      <v-col cols="3">
        <!-- 1 IN CREATION STATUS-->
        <v-row cols="12" class="pb-0">
          <div class="status-content" :class="isCreationStatus()">
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.IN_CREATION') }}
            </p>
            <img
              v-if="isCreationStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 2 TRANSPORT GO STATUS-->
        <v-row cols="12" class="pb-0">
          <div class="status-content" :class="isTransportGoStatus()">
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.TRANSPORT_GO') }}
            </p>
            <img
              v-if="isTransportGoStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 3 RECEPTION_AT_REPAIRER STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isReceptionAtRepairer()"
            @click="
              isReceptionAtRepairer() === 'clickable'
                ? openChangeStatusConfirmation(RepairFileStatusMacroConstant.RECEPTION_AT_REPAIRER)
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.RECEPTION_AT_REPAIRER') }}
            </p>
            <img
              v-if="isReceptionAtRepairer() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 4 DIAGNOSTIC_MANUFACTURER_RECEIVED STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isDiagnosticManufacturerReceivedStatus()"
            @click="
              isDiagnosticManufacturerReceivedStatus() === 'clickable'
                ? openChangeStatusConfirmation(
                    RepairFileStatusMacroConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED
                  )
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.DIAGNOSTIC_MANUFACTURER_RECEIVED') }}
            </p>
            <img
              v-if="isDiagnosticManufacturerReceivedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 5 DIAGNOSTIC_MANUFACTURER_PROCESSED STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isDiagnosticManufacturerProcessedStatus()"
            @click="
              isDiagnosticManufacturerProcessedStatus() === 'clickable'
                ? openChangeStatusConfirmation(
                    RepairFileStatusMacroConstant.DIAGNOSTIC_MANUFACTURER_PROCESSED
                  )
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.DIAGNOSTIC_MANUFACTURER_PROCESSED') }}
            </p>
            <img
              v-if="isDiagnosticManufacturerProcessedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 6 ESTIMATE_SENT_TO_CUSTOMER STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isEstimateSentToCustomerStatus()"
            @click="
              isEstimateSentToCustomerStatus() === 'clickable'
                ? openChangeStatusConfirmation(
                    RepairFileStatusMacroConstant.ESTIMATE_SENT_TO_CUSTOMER
                  )
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.ESTIMATE_SENT_TO_CUSTOMER') }}
            </p>
            <img
              v-if="isEstimateSentToCustomerStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 7 ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isCustomerDecisionSentStatus()"
            @click="
              isCustomerDecisionSentStatus() === 'clickable'
                ? openChangeStatusConfirmation(
                    RepairFileStatusMacroConstant.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER
                  )
                : null
            "
          >
            <p class="status-detail">
              {{
                $t(
                  'REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER'
                )
              }}
            </p>
            <img
              v-if="isCustomerDecisionSentStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 8 IN_REPARATION STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isInReparationStatus()"
            @click="
              isInReparationStatus() === 'clickable'
                ? openChangeStatusConfirmation(RepairFileStatusMacroConstant.IN_REPARATION)
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.IN_REPARATION') }}
            </p>
            <img
              v-if="isInReparationStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 9 SENT_BACK_BY_REPAIRER STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isTransportBackStatus()"
            @click="
              isTransportBackStatus() === 'clickable'
                ? openChangeStatusConfirmation(RepairFileStatusMacroConstant.SENT_BACK_BY_REPAIRER)
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.SENT_BACK_BY_REPAIRER') }}
            </p>
            <img
              v-if="isTransportBackStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 10 RECEIPT_AT_STORE STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isReceiptAtStoreStatus()"
            @click="
              isReceiptAtStoreStatus() === 'clickable'
                ? openChangeStatusConfirmation(RepairFileStatusMacroConstant.RECEIPT_AT_STORE)
                : null
            "
          >
            <p class="status-detail green bold">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.RECEIPT_AT_STORE') }}
            </p>
            <img
              v-if="isReceiptAtStoreStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 11 SENT_AVAILABLE_TO_CUSTOMER STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isSendAvailableToCustomerStatus()"
            @click="
              isSendAvailableToCustomerStatus() === 'clickable'
                ? openChangeStatusConfirmation(
                    RepairFileStatusMacroConstant.SENT_AVAILABLE_TO_CUSTOMER
                  )
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.SENT_AVAILABLE_TO_CUSTOMER') }}
            </p>
            <img
              v-if="isSendAvailableToCustomerStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 12 TAKEOVER_BY_CUSTOMER STATUS-->
        <v-row cols="12" class="pb-0">
          <div class="status-content" :class="isTakeOverByCustomerStatus()">
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.TAKEOVER_BY_CUSTOMER') }}
            </p>
            <img
              v-if="isTakeOverByCustomerStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 13 NETWORK_BILLING STATUS-->
        <v-row cols="12" class="pb-0">
          <div class="status-content" :class="isBillingStatus()">
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.NETWORK_BILLING') }}
            </p>
            <img
              v-if="isBillingStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 14 FINISHED STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isFinishedStatus()"
            @click="
              isFinishedStatus() === 'clickable'
                ? openChangeStatusConfirmation(RepairFileStatusMacroConstant.FINISHED)
                : null
            "
          >
            <p class="status-detail">
              {{ $t('REPAIR_FILE_GLOBAL_INFO.STATUS_DISPLAY.FINISHED') }}
            </p>
            <img
              v-if="isFinishedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg"
            />
          </div>
        </v-row>
      </v-col>

      <!--Global informations-->
      <v-col cols="9">
        <!--TITLE AND NEW ACTION BUTTON-->
        <v-row class="header-content">
          <v-col>
            <p class="title">{{ $t('REPAIR_FILE_GLOBAL_INFO.HEADER.TITLE') }}</p>
          </v-col>
          <v-col align="center">{{ calculateDate() }}</v-col>
          <v-col>
            <v-btn class="button" @click="openNavigationDrawer()">
              <img
                alt="cross-svg"
                class="cross-rounded-svg"
                src="@/assets/icons/file/cross_round.svg"
              />
              <p class="btn-label">{{ $t('REPAIR_FILE_GLOBAL_INFO.BUTTON.NEW_ACTION') }}</p>
            </v-btn>
          </v-col>
        </v-row>

        <!--PRODUCT CARD-->
        <v-row>
          <v-col cols="2">
            <v-img
              :src="currentRepairFile?.product_picture"
              class="picture-content"
              alt="Image produit"
            />
          </v-col>
          <v-col cols="10">
            <v-row>
              <v-col class="px-0 pb-1" cols="12">
                <p class="sub-title">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRODUCT') }}
                </p>
                <div class="underline" />
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.MANUFACTURER') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.manufacturer_name
                      ? currentRepairFile.manufacturer_name
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CATEGORY') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.category_name
                      ? currentRepairFile.category_name
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.SUB_CATEGORY') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.sub_category_name
                      ? currentRepairFile.sub_category_name
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PRODUCT') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.product_name
                      ? currentRepairFile.product_name
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.SERIAL_NUMBER') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.product_serial_number
                      ? currentRepairFile.product_serial_number
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!--CONTACT CARD-->
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col class="px-0 pb-1" cols="12">
                <p class="sub-title">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.CONTACT') }}
                </p>
                <div class="underline" />
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.LASTNAME') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.lastname ? currentRepairFile.lastname : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.EMAIL') }}
                </p>
                <p class="text">
                  {{ currentRepairFile.email ? currentRepairFile.email : $t('COMMON.NO_VALUE') }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PHONE_NUMBER') }}
                </p>
                <p class="text">
                  {{
                    currentRepairFile.phone_number
                      ? currentRepairFile.phone_number
                      : $t('COMMON.NO_VALUE')
                  }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!--SUPPORT CARD-->
        <v-row>
          <v-col cols="12">
            <v-row>
              <!--TITLE-->
              <v-col class="px-0 pb-1" cols="12">
                <p
                  v-if="currentRepairFile.folder_type === FolderTypeConstant.REPAIR_FOLDER"
                  class="sub-title"
                >
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.SUPPORT') }}
                </p>
                <p
                  v-if="currentRepairFile.folder_type === FolderTypeConstant.PROSPECT_FOLDER"
                  class="sub-title"
                >
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.SUPPORT') }} -
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PROSPECT_FLOW') }}
                </p>
                <div class="underline" />
              </v-col>
              <!--SUPPORT STATUS-->
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.SUPPORT') }}
                </p>
                <p v-if="currentRepairFile.initial_pricing_type" class="text">
                  {{ isInGuarantee() }} {{ isInitialPackageOrEstimate() }}
                </p>
                <p v-else class="text">{{ isInGuarantee() }}</p>
              </v-col>
              <!--ELEMENT(S)-->
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ELEMENT') }}
                </p>
                <div class="d-flex" v-if="currentRepairFile.product_guarantee_list">
                  <p
                    class="text"
                    v-for="(product, index) in currentRepairFile.product_guarantee_list"
                    :key="index"
                  >
                    {{ $t('COMMON.PRODUCT_TYPE.' + product.product_type) }}
                    {{ index < currentRepairFile.product_guarantee_list.length - 1 ? ' ,' : '' }}
                  </p>
                </div>
                <p v-else class="text">-</p>
              </v-col>
              <!--GUARANTEE INITIAL TIME-->
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.GUARANTEE') }}
                </p>
                <p class="text">
                  {{ getCommercialGuarantee() }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!--PRICING CARD-->
        <v-row>
          <v-col cols="12">
            <v-row>
              <!--TITLE-->
              <v-col class="px-0 pb-1" cols="12">
                <div class="sub-title">
                  <!--GUARANTEE - PACKAGE-->
                  <p
                    v-if="
                      currentRepairFile.status_guarantee !==
                        RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                      currentRepairFile.initial_pricing_type ===
                        RepairFilePricingTypeConstant.PACKAGE &&
                      !repairerEstimateOfferOptionIsSelected &&
                      !repairerEstimateOfferOptionList
                    "
                  >
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRICING') }} -
                    {{ $t('COMMON.PRICING_TYPE.PACKAGE') }}
                  </p>

                  <!--GUARANTEE - DEVIS-->
                  <p
                    v-if="
                      currentRepairFile.status_guarantee !==
                        RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                      currentRepairFile.initial_pricing_type ===
                        RepairFilePricingTypeConstant.ESTIMATE &&
                      !repairerEstimateOfferOptionIsSelected &&
                      !repairerEstimateOfferOptionList
                    "
                  >
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRICING') }} -
                    {{ $t('COMMON.PRICING_TYPE.ESTIMATE') }}
                  </p>

                  <!--GUARANTEE - REPAIRER DEVIS-->
                  <p
                    v-if="
                      currentRepairFile.status_guarantee !==
                        RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                      currentRepairFile.repairer_estimate_pricing_type ===
                        RepairFilePricingTypeConstant.ESTIMATE
                    "
                  >
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRICING') }} -
                    {{ $t('COMMON.PRICING_TYPE.ESTIMATE') }}
                  </p>

                  <!--WITHOUT GUARANTEE - PACKAGE-->
                  <p
                    v-if="
                      currentRepairFile.status_guarantee ===
                        RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                      currentRepairFile.initial_pricing_type ===
                        RepairFilePricingTypeConstant.PACKAGE &&
                      currentRepairFile.repairer_estimate_pricing_type === null
                    "
                  >
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRICING') }} -
                    {{ $t('COMMON.PRICING_TYPE.PACKAGE') }}
                  </p>

                  <!--WITHOUT GUARANTEE - DEVIS-->
                  <p
                    v-if="
                      currentRepairFile.status_guarantee ===
                        RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                      (currentRepairFile.initial_pricing_type ===
                        RepairFilePricingTypeConstant.ESTIMATE ||
                        (currentRepairFile.repairer_estimate_pricing_type !== null &&
                          currentRepairFile.repairer_estimate_pricing_type ===
                            RepairFilePricingTypeConstant.ESTIMATE))
                    "
                  >
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TITLE.PRICING') }} -
                    {{ $t('COMMON.PRICING_TYPE.ESTIMATE') }}
                  </p>
                </div>
                <div class="underline" />
              </v-col>

              <!--GUARANTEE - PACKAGE-->
              <div
                v-if="
                  currentRepairFile.status_guarantee !==
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type === null
                "
              >
                <!-- Display nothing -->
              </div>

              <!--GUARANTEE - ESTIMATE - WAITING CLIENT CHOICE - NOT TAKEOVER BY CLIENT -->
              <template
                v-if="
                  currentRepairFile.status_guarantee !==
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE &&
                  isCustomerDecisionSentStatus() === 'reachable' &&
                  repairFileIsTakeover() === false
                "
              >
                <!-- Show Repairer Offer list -->
                <template
                  v-for="option in repairerEstimateOfferOptionList"
                  :key="option.technical_id"
                >
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mt-1" cols="12">
                    <p class="text grey bold">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                            option.offer_type.toUpperCase()
                        )
                      }}
                    </p>
                  </v-col>

                  <!--REPAIRER COST-->
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_COST') }}
                    </p>
                    <p class="text">
                      {{
                        (option.estimate_cost + option.transport_cost + option.labor_cost).toFixed(
                          2
                        ) +
                        ' ' +
                        $t('COMMON.EURO')
                      }}
                    </p>
                  </v-col>
                  <!--CLIENT COST-->
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                    </p>
                    <p class="text">
                      {{ option.total_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}
                    </p>
                  </v-col>
                </template>
              </template>

              <!--GUARANTEE - ESTIMATE - CLIENT CHOICE DONE - NOT TAKEOVER BY CLIENT -->
              <template
                v-if="
                  currentRepairFile.status_guarantee !==
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE &&
                  isCustomerDecisionSentStatus() !== 'reachable' &&
                  repairFileIsTakeover() === false
                "
              >
                <!-- Show Repairer Offer selected -->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_BY_CUSTOMER')
                    }}
                  </p>
                  <p class="text">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                          repairerEstimateOfferOptionIsSelected?.offer_type.toUpperCase()
                      )
                    }}
                  </p>
                </v-col>
                <!--REPAIRER COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_COST') }}
                  </p>
                  <p class="text">
                    {{
                      (
                        repairerEstimateOfferOptionIsSelected?.estimate_cost +
                        repairerEstimateOfferOptionIsSelected?.transport_cost +
                        repairerEstimateOfferOptionIsSelected?.labor_cost
                      ).toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <!--CLIENT COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                  </p>
                  <p class="text">
                    {{
                      (repairerEstimateOfferOptionIsSelected?.total_cost).toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
              </template>

              <!--GUARANTEE - ESTIMATE - TAKEOVER BY CLIENT -->
              <template
                v-if="
                  currentRepairFile.status_guarantee !==
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE &&
                  repairFileIsTakeover() === true
                "
              >
                <!--Show Takeover detail with some repairer offer detail-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                          currentRepairFile?.takeover_product_status.toUpperCase()
                      )
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_repairer_total_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_TRANSPORT_COST'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_transport_cost.toFixed(2) + ' ' + $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ADDITIONAL_REPAIR_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_additional_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_client_price.toFixed(2) + ' ' + $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
              </template>

              <!--NOT GUARANTEE - PACKAGE - NOT TAKEOVER BY CLIENT-->
              <template
                v-if="
                  currentRepairFile.status_guarantee ===
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.initial_pricing_type ===
                    RepairFilePricingTypeConstant.PACKAGE &&
                  repairFileIsTakeover() === false &&
                  currentRepairFile.repairer_estimate_pricing_type !==
                    RepairFilePricingTypeConstant.ESTIMATE
                "
              >
                <!-- Show package information -->
                <!--NETWORK_PACKAGE_CODE-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.NETWORK_PACKAGE_CODE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.package_network_code
                        ? currentRepairFile.package_network_code
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <!--PACKAGE_CODE-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PACKAGE_CODE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.package_code
                        ? currentRepairFile.package_code
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>

                <!--CLIENT-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mt-2" cols="12">
                  <p class="text grey bold">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CLIENT_LABEL') }}
                  </p>
                </v-col>
                <!--REPAIR_COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.REPAIR_COST') }}
                  </p>
                  <p class="text">
                    {{ this.displayPackageRepairCost(currentRepairFile.package_client_price) }}
                  </p>
                </v-col>
                <!--TRANSPORT_COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TRANSPORT_PRICE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.initial_package_transport_cost
                        ? currentRepairFile.initial_package_transport_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <!--MANAGEMENT_COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.MANAGEMENT_PRICE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.initial_package_additional_repair_cost
                        ? currentRepairFile.initial_package_additional_repair_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>

                <!--REPAIRER-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mt-2" cols="12">
                  <p class="text grey bold">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.REPAIRER_LABEL') }}
                  </p>
                </v-col>
                <!--Package REPAIRER COST VALUE-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.REPAIRER_COST_MAX') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.package_repairer_cost_value
                        ? currentRepairFile.package_repairer_cost_value.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
              </template>

              <!--NOT GUARANTEE - PACKAGE - TAKEOVER BY CLIENT-->
              <template
                v-if="
                  currentRepairFile.status_guarantee ===
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.initial_pricing_type ===
                    RepairFilePricingTypeConstant.PACKAGE &&
                  currentRepairFile.repairer_estimate_pricing_type === null &&
                  repairFileIsTakeover() === true
                "
              >
                <!-- Show Takeover detail with some package information -->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.NETWORK_PACKAGE_CODE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.package_network_code
                        ? currentRepairFile.package_network_code
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PACKAGE_CODE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.package_code
                        ? currentRepairFile.package_code
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PACKAGE_TOTAL_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_repairer_total_cost
                        ? currentRepairFile.takeover_repairer_total_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.PACKAGE_SUPPORT_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_client_price
                        ? currentRepairFile.takeover_client_price.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TRANSPORT_PRICE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_transport_cost
                        ? currentRepairFile.takeover_transport_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.MANAGEMENT_PRICE') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_additional_cost
                        ? currentRepairFile.takeover_additional_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_client_total_cost
                        ? currentRepairFile.takeover_client_total_cost.toFixed(2) +
                          ' ' +
                          $t('COMMON.EURO')
                        : $t('COMMON.NO_VALUE')
                    }}
                  </p>
                </v-col>
              </template>

              <!--NOT GUARANTEE - ESTIMATE - WAITING CLIENT CHOICE - NOT TAKEOVER BY CLIENT-->
              <template
                v-if="
                  currentRepairFile.status_guarantee ===
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type !== null &&
                  currentRepairFile.repairer_estimate_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE &&
                  isDiagnosticManufacturerProcessedStatus() !== 'reachable' &&
                  isCustomerDecisionSentStatus() === 'reachable' &&
                  repairFileIsTakeover() === false
                "
              >
                <!-- Show Repairer Offer list -->
                <template
                  v-for="option in repairerEstimateOfferOptionList"
                  :key="option.technical_id"
                >
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mt-1" cols="12">
                    <p class="text grey bold">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                            option.offer_type.toUpperCase()
                        )
                      }}
                    </p>
                  </v-col>

                  <!--REPAIRER COMMENT-->
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey font-italic">
                      {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.COMMENT') }}
                      {{ option.comment }}
                    </p>
                  </v-col>

                  <!--REPAIRER COST-->
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST'
                        )
                      }}
                    </p>
                    <p class="text">
                      {{ option.estimate_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}
                    </p>
                  </v-col>
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST'
                        )
                      }}
                    </p>
                    <p class="text">
                      {{ option.transport_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}
                    </p>
                  </v-col>
                  <v-col
                    v-if="option.offer_type === 'PRODUCT_REPAIRED'"
                    class="px-0 pt-0 pb-1 d-flex justify-space-between"
                    cols="12"
                  >
                    <p class="text grey">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_LABOR_COST'
                        )
                      }}
                    </p>
                    <p class="text">
                      {{ option.labor_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}
                    </p>
                  </v-col>
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{
                        $t(
                          'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_REPAIR_COST'
                        )
                      }}
                    </p>
                    <p class="text">
                      {{
                        (option.estimate_cost + option.transport_cost + option.labor_cost).toFixed(
                          2
                        ) +
                        ' ' +
                        $t('COMMON.EURO')
                      }}
                    </p>
                  </v-col>
                  <!--CLIENT COST-->
                  <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                    <p class="text grey">
                      {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                    </p>
                    <p class="text">
                      {{ option.total_cost?.toFixed(2) + ' ' + $t('COMMON.EURO') }}
                    </p>
                  </v-col>
                </template>
              </template>

              <!--NOT GUARANTEE - ESTIMATE - CLIENT CHOICE DONE - NOT TAKEOVER BY CLIENT-->
              <template
                v-if="
                  currentRepairFile.status_guarantee ===
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  currentRepairFile.repairer_estimate_pricing_type !== null &&
                  currentRepairFile.repairer_estimate_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE &&
                  isCustomerDecisionSentStatus() !== 'reachable' &&
                  repairFileIsTakeover() === false &&
                  repairerEstimateOfferOptionIsSelected
                "
              >
                <!-- Show Repairer Offer selected -->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_BY_CUSTOMER')
                    }}
                  </p>
                  <p class="text">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                          repairerEstimateOfferOptionIsSelected?.offer_type.toUpperCase()
                      )
                    }}
                  </p>
                </v-col>

                <!--REPAIRER COMMENT-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey font-italic">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.COMMENT') }}
                    {{ repairerEstimateOfferOptionIsSelected?.comment }}
                  </p>
                </v-col>

                <!-- REPAIRER COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_ESTIMATE_COST'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      repairerEstimateOfferOptionIsSelected.estimate_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_TRANSPORT_COST'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      repairerEstimateOfferOptionIsSelected.transport_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col
                  v-if="repairerEstimateOfferOptionIsSelected.offer_type === 'PRODUCT_REPAIRED'"
                  class="px-0 pt-0 pb-1 d-flex justify-space-between"
                  cols="12"
                >
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_DETAIL_LABOR_COST'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      repairerEstimateOfferOptionIsSelected.labor_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_COST') }}
                  </p>
                  <p class="text">
                    {{
                      (
                        repairerEstimateOfferOptionIsSelected?.estimate_cost +
                        repairerEstimateOfferOptionIsSelected?.transport_cost +
                        repairerEstimateOfferOptionIsSelected?.labor_cost
                      ).toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <!-- CLIENT COST-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                  </p>
                  <p class="text">
                    {{
                      (repairerEstimateOfferOptionIsSelected?.total_cost).toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
              </template>

              <!--NOT GUARANTEE - ESTIMATE - TAKEOVER BY CLIENT-->
              <template
                v-if="
                  currentRepairFile.status_guarantee ===
                    RepairFileGuaranteeConstant.NOT_GUARANTEE &&
                  (currentRepairFile.initial_pricing_type ===
                    RepairFilePricingTypeConstant.ESTIMATE ||
                    (currentRepairFile.repairer_estimate_pricing_type !== null &&
                      currentRepairFile.repairer_estimate_pricing_type ===
                        RepairFilePricingTypeConstant.ESTIMATE)) &&
                  repairFileIsTakeover() === true
                "
              >
                <!--Show Takeover detail with some repairer offer detail-->
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_TAKEOVER_BY_CUSTOMER'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.ESTIMATE_OPTION_STATUS.' +
                          currentRepairFile?.takeover_product_status.toUpperCase()
                      )
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_repairer_total_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{
                      $t(
                        'REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ESTIMATE_VALIDATE_TRANSPORT_COST'
                      )
                    }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_transport_cost.toFixed(2) + ' ' + $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.ADDITIONAL_REPAIR_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_additional_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
                <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                  <p class="text grey">
                    {{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.CUSTOMER_END_COST') }}
                  </p>
                  <p class="text">
                    {{
                      currentRepairFile.takeover_client_total_cost.toFixed(2) +
                      ' ' +
                      $t('COMMON.EURO')
                    }}
                  </p>
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--RECAP AT BOTTOM-->
    <v-row class="total-row-container">
      <div class="total-content">
        <!--LEFT PART-->
        <div class="bottom-left-part">
          <div class="client-validation" v-if="repairFileIsTakeover() === true">
            <p>{{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.TAKEOVER_BY_CUSTOMER') }}</p>
            <p class="repair-content" v-if="currentRepairFile.takeover_product_status">
              {{ $t('COMMON.PRODUCT_END_STATUS.' + currentRepairFile.takeover_product_status) }}
            </p>
            <p class="repair-content" v-else>
              {{ $t('COMMON.PRODUCT_END_STATUS.DEFAULT') }}
            </p>
          </div>
          <div class="client-validation" v-else>
            <p>{{ $t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.REPAIR_FILE_IN_PROGRESS') }}</p>
          </div>

          <div
            v-if="
              currentRepairFile.takeover_billing_number &&
              currentRepairFile.takeover_billing_number !== 'NA'
            "
            class="billing-number"
          >
            {{ currentRepairFile.takeover_billing_number }}
          </div>
        </div>

        <!--RIGHT PART-->
        <div class="total-price">
          <p v-if="repairFileIsTakeover() === true" class="pr-5">
            {{ currentRepairFile.takeover_client_total_cost.toFixed(2) + ' ' + $t('COMMON.EURO') }}
          </p>
          <p
            v-else-if="
              repairFileIsTakeover() === false &&
              currentRepairFile.repairer_estimate_pricing_type ===
                RepairFilePricingTypeConstant.ESTIMATE &&
              repairerEstimateOfferOptionIsSelected !== undefined
            "
            class="pr-5"
          >
            {{
              repairerEstimateOfferOptionIsSelected?.total_cost.toFixed(2) + ' ' + $t('COMMON.EURO')
            }}
          </p>
          <p
            v-else-if="
              repairFileIsTakeover() === false &&
              currentRepairFile.repairer_estimate_pricing_type ===
                RepairFilePricingTypeConstant.ESTIMATE &&
              repairerEstimateOfferOptionIsSelected === undefined
            "
            class="pr-5"
          >
            - {{ $t('COMMON.EURO') }}
          </p>
          <p
            v-else-if="
              currentRepairFile.initial_pricing_type === RepairFilePricingTypeConstant.ESTIMATE
            "
            class="pr-5"
          >
            - {{ $t('COMMON.EURO') }}
          </p>
          <p v-else class="pr-5">
            {{ this.displayPackageRepairCost(currentRepairFile.initial_package_total_repair_cost) }}
          </p>
        </div>
      </div>
    </v-row>
  </v-card>
  <RightNavigationDrawer
    v-model="navigationDrawerOpen"
    :currentRepairFile="currentRepairFile"
    :rentalFileId="rentalFileId"
    :newActionComponentProps="navigationDrawerOpen"
    @updateCurrentRepairFile="handleUpdateRepairFile()"
    @showUpdateRepairFileStatusModal="handleShowUpdateRepairFileStatusModal()"
    @close="closeNavigationDrawer()"
    @showGuaranteeExtensionBoomerangModal="handleShowGuaranteeExtensionBoomerangModal()"
    @openRentalWarningModal="handleOpenRentalWarningModal()"
  />
  <UpdateStatusFormModal ref="updateRepairFileStatusModal" />
  <UpdateStatusConfirmationModal ref="updateRepairFileStatusConfirmationModal" />
  <GuaranteeExtensionBoomerangModal ref="showGuaranteeExtensionBoomerangModal" />
  <RentalWarningModal ref="rentalWarningModal" />
</template>

<script>
import RepairFileGuaranteeConstant from '@/constants/repairFileGuaranteeConstant'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import RightNavigationDrawer from '@/components/repair-file-module/folder-lifecycle/navigation-drawer/RightNavigationDrawer.vue'
import UpdateStatusFormModal from '@/components/modal/repair-file/UpdateStatusFormModal.vue'
import UpdateStatusConfirmationModal from '@/components/modal/repair-file/UpdateStatusConfirmationModal.vue'
import RepairFileStatusMacroConstant from '@/constants/repairFileStatusMacroConstant'
import RepairFilePricingTypeConstant from '@/constants/repairFilePricingTypeConstant'
import { RepairFile } from '@/models/RepairFile'
import GuaranteeExtensionBoomerangModal from '@/components/modal/repair-file/GuaranteeExtensionBoomerangModal.vue'
import {
  displayToast,
  checkPermission,
  shouldShowTooltip,
  handleResponseError
} from '@/components/utils/globalFunction'
import RentalFileService from '@/services/rentalModule/RentalFileService'
import FolderTypeConstant from '@/constants/repairModule/FolderTypeConstant'
import RentalWarningModal from '@/components/modal/repair-file/detail/new-action-panel/RentalWarningModal.vue'

export default {
  name: 'GlobalRepairFileInfo',
  computed: {
    FolderTypeConstant() {
      return FolderTypeConstant
    },
    RepairFilePricingTypeConstant() {
      return RepairFilePricingTypeConstant
    },
    RepairFileGuaranteeConstant() {
      return RepairFileGuaranteeConstant
    },
    RepairFileStatusDetailConstant() {
      return RepairFileStatusDetailConstant
    },
    RepairFileStatusMacroConstant() {
      return RepairFileStatusMacroConstant
    }
  },
  components: {
    RentalWarningModal,
    GuaranteeExtensionBoomerangModal,
    UpdateStatusConfirmationModal,
    UpdateStatusFormModal,
    RightNavigationDrawer
  },
  props: {
    currentRepairFile: RepairFile
  },
  data() {
    return {
      loading: false,
      error: null,
      navigationDrawerOpen: false,
      repairerEstimateOfferOptionIsSelected: null,
      repairerEstimateOfferOptionList: null,

      rentalFileId: null
    }
  },
  watch: {
    async currentRepairFile() {
      this.repairerEstimateOfferOptionList =
        this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list
      this.repairerEstimateOfferOptionIsSelected =
        this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list.find(
          (option) => option.is_selected === true
        )
    }
  },
  async created() {
    this.repairerEstimateOfferOptionList =
      this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list
    this.repairerEstimateOfferOptionIsSelected =
      this.currentRepairFile?.repairer_estimate?.repairer_estimate_option_list?.find(
        (option) => option.is_selected === true
      )

    if (checkPermission(['DISTRIBUTOR_RENTAL_READ'])) {
      await this.getRentalFileId()
    }
  },
  methods: {
    shouldShowTooltip,
    checkPermission,
    async getRentalFileId() {
      try {
        const response = await RentalFileService.getRentalFileByRepairFileId(
          this.currentRepairFile.technical_id
        )
        this.rentalFileId = response.rental_file_id
      } catch (error) {
        this.rentalFileId = null
        // Do Nothing
      }
    },
    calculateDate() {
      if (!this.currentRepairFile.business_created_day_count) {
        return '0 ' + this.$t('REPAIR_FILE_GLOBAL_INFO.HEADER.DAY')
      }
      if (this.currentRepairFile.business_created_day_count > 1)
        return (
          this.currentRepairFile.business_created_day_count +
          ' ' +
          this.$t('REPAIR_FILE_GLOBAL_INFO.HEADER.DAYS')
        )
      return (
        this.currentRepairFile.business_created_day_count +
        ' ' +
        this.$t('REPAIR_FILE_GLOBAL_INFO.HEADER.DAY')
      )
    },
    isInGuarantee() {
      if (this.currentRepairFile.status_guarantee) {
        if (this.currentRepairFile.status_guarantee !== RepairFileGuaranteeConstant.NOT_GUARANTEE) {
          return this.$t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.UNDER_GUARANTEE')
        }
        return this.$t('REPAIR_FILE_GLOBAL_INFO.REPAIR_FILE_INFO.OUT_GUARANTEE')
      } else {
        return this.$t('COMMON.NO_VALUE')
      }
    },
    isInitialPackageOrEstimate() {
      if (this.currentRepairFile.initial_pricing_type) {
        if (this.currentRepairFile.initial_pricing_type === RepairFilePricingTypeConstant.PACKAGE) {
          return ' - ' + this.$t('COMMON.PRICING_TYPE.PACKAGE')
        } else if (
          this.currentRepairFile.initial_pricing_type === RepairFilePricingTypeConstant.ESTIMATE
        ) {
          return ' - ' + this.$t('COMMON.PRICING_TYPE.ESTIMATE')
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    getCommercialGuarantee() {
      if (this.currentRepairFile.product_commercial_guarantee) {
        if (this.currentRepairFile.product_commercial_guarantee === 1) {
          return `${this.currentRepairFile.product_commercial_guarantee} ${this.$t('COMMON.DAY')}`
        }
        return `${this.currentRepairFile.product_commercial_guarantee} ${this.$t('COMMON.DAYS')}`
      } else {
        return this.$t('COMMON.NO_VALUE')
      }
    },
    isCreationStatus() {
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.PRODUCT_SELECTED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.GUARANTEE_EVALUATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PRICING_SENT_TO_CUSTOMER ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.PRICING_EVALUATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.INFORMATION_RETRIEVED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_CLIENT_INFORMATION_RETRIEVED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_REQUEST_SENT ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.PROSPECT_MANUFACTURER_RESPONSE_VALIDATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.TRANSPORTER_REPAIR_FILE_TRANSFER ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.FINALIZE_REPAIR_FILE
      ) {
        return 'active-status'
      } else {
        return 'outdated-status'
      }
    },
    isTransportGoStatus() {
      if (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.REPAIR_FILE_CREATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.COLLECTION_TO_REPAIRER
      ) {
        return 'active-status'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'outdated-status'
      } else {
        return ''
      }
    },
    isReceptionAtRepairer() {
      if (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.RECEPTION_AT_REPAIRER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'clickable'
      } else {
        return ''
      }
    },
    isDiagnosticManufacturerReceivedStatus() {
      if (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.DIAGNOSTIC_MANUFACTURER_RECEIVED
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'clickable'
      } else {
        return ''
      }
    },
    isDiagnosticManufacturerProcessedStatus() {
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.ESTIMATE_CREATED ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.FORCE_ESTIMATE_CREATED
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.FORCE_ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'reachable'
      } else {
        return ''
      }
    },
    isEstimateSentToCustomerStatus() {
      if (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.FORCE_ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED
      ) {
        return 'clickable'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'reachable'
      } else {
        return ''
      }
    },
    isCustomerDecisionSentStatus() {
      if (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER ||
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.FORCE_ESTIMATE_CUSTOMER_DECISION_SENT_TO_REPAIRER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else if (this.isCreationStatus() === 'outdated-status') {
        return 'reachable'
      } else {
        return ''
      }
    },
    isInReparationStatus() {
      if (this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.IN_REPARATION) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isTransportBackStatus() {
      if (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.SENT_BACK_BY_REPAIRER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status' &&
        this.isInReparationStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isReceiptAtStoreStatus() {
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.RECEIPT_AT_STORE
      ) {
        return 'active-status black'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status' &&
        this.isInReparationStatus() === 'outdated-status' &&
        this.isTransportBackStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isSendAvailableToCustomerStatus() {
      if (
        this.currentRepairFile.status_detail ===
        RepairFileStatusDetailConstant.SENT_AVAILABLE_TO_CUSTOMER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status' &&
        this.isInReparationStatus() === 'outdated-status' &&
        this.isTransportBackStatus() === 'outdated-status' &&
        this.isReceiptAtStoreStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.currentRepairFile.status_detail !== RepairFileStatusDetailConstant.ESTIMATE_CREATED &&
        this.currentRepairFile.status_detail !==
          RepairFileStatusDetailConstant.ESTIMATE_SENT_TO_CUSTOMER
      ) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isTakeOverByCustomerStatus() {
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.TAKEOVER_BY_CUSTOMER
      ) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status' &&
        this.isInReparationStatus() === 'outdated-status' &&
        this.isTransportBackStatus() === 'outdated-status' &&
        this.isReceiptAtStoreStatus() === 'outdated-status' &&
        this.isSendAvailableToCustomerStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else {
        return ''
      }
    },
    isBillingStatus() {
      if (this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.NETWORK_BILLING) {
        return 'active-status'
      } else if (
        this.isCreationStatus() === 'outdated-status' &&
        this.isTransportGoStatus() === 'outdated-status' &&
        this.isReceptionAtRepairer() === 'outdated-status' &&
        this.isDiagnosticManufacturerReceivedStatus() === 'outdated-status' &&
        this.isDiagnosticManufacturerProcessedStatus() === 'outdated-status' &&
        this.isEstimateSentToCustomerStatus() === 'outdated-status' &&
        this.isCustomerDecisionSentStatus() === 'outdated-status' &&
        this.isInReparationStatus() === 'outdated-status' &&
        this.isTransportBackStatus() === 'outdated-status' &&
        this.isReceiptAtStoreStatus() === 'outdated-status' &&
        this.isSendAvailableToCustomerStatus() === 'outdated-status' &&
        this.isTakeOverByCustomerStatus() === 'outdated-status'
      ) {
        return 'outdated-status'
      } else {
        return ''
      }
    },
    isFinishedStatus() {
      if (
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.FINISHED ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.ABORT_BY_CUSTOMER ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.DELETED
      ) {
        return 'active-status'
      } else if (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.TAKEOVER_BY_CUSTOMER ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.NETWORK_BILLING
      ) {
        return 'clickable'
      } else {
        return ''
      }
    },
    openNavigationDrawer() {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        if (this.navigationDrawerOpen === false) {
          this.navigationDrawerOpen = true
        }
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    async handleUpdateRepairFile() {
      this.$emit('updateCurrentRepairFile')
    },
    closeNavigationDrawer() {
      this.navigationDrawerOpen = false
    },
    async handleShowUpdateRepairFileStatusModal() {
      const statusUpdated = await this.$refs.updateRepairFileStatusModal.show({
        currentRepairFile: this.currentRepairFile
      })

      if (statusUpdated) {
        this.$emit('updateCurrentRepairFile')
      }
    },
    async openChangeStatusConfirmation(statusAsked) {
      if (checkPermission(['DISTRIBUTOR_UPDATE_REPAIR_FILE'])) {
        if (this.isCreationStatus() !== 'active-status') {
          const statusUpdated = await this.$refs.updateRepairFileStatusConfirmationModal.show({
            nextStatus: statusAsked,
            currentRepairFile: this.currentRepairFile
          })

          if (statusUpdated) {
            this.$emit('updateCurrentRepairFile')
          }
        }
      } else {
        displayToast(this.$t('COMMON.NOT_AUTHORIZED_ACTION_MESSAGE'), 'warning')
      }
    },
    displayPackageRepairCost(packageClientPrice) {
      if (typeof packageClientPrice === 'string') {
        return packageClientPrice
      } else if (typeof packageClientPrice === 'number') {
        return packageClientPrice.toFixed(2) + ' ' + this.$t('COMMON.EURO')
      } else {
        return this.$t('COMMON.NO_VALUE')
      }
    },
    async handleShowGuaranteeExtensionBoomerangModal() {
      try {
        await this.$refs.showGuaranteeExtensionBoomerangModal.show({
          repairFileBoomerangId: this.currentRepairFile.boomerang_id
        })
      } catch (error) {
        handleResponseError(error)
      }
    },
    repairFileIsTakeover() {
      return (
        this.currentRepairFile.status_detail ===
          RepairFileStatusDetailConstant.TAKEOVER_BY_CUSTOMER ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.NETWORK_BILLING ||
        this.currentRepairFile.status_detail === RepairFileStatusDetailConstant.FINISHED
      )
    },
    async handleOpenRentalWarningModal() {
      await this.$refs.rentalWarningModal.show()
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 32px;
  overflow: unset;
}

.header-content {
  display: flex;
  align-items: center;
  align-self: stretch;
}

.title {
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.button {
  border-radius: 20px;
  background: #000;
}

.cross-rounded-svg {
  width: 14px;
  height: 14px;
  filter: invert(100%) sepia(0%) saturate(7481%) hue-rotate(181deg) brightness(108%) contrast(100%);
  margin-right: 4px;
}

.btn-label {
  color: #fff;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.status-detail {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 18px */
  letter-spacing: -0.132px;
}

.status-content {
  width: fit-content;
  display: flex;
  padding: 4px 10px;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  color: #acacac;
  background: white;
}

.svg-check-rounded {
  width: 14px;
  height: 14px;
}

.picture-content {
  width: 83px;
  height: 83px;
}

.sub-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
}

.text {
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: black;
}

.grey {
  color: #acacac;
}

.green {
  color: #86c94e;
}

.bold {
  font-weight: bold;
}

.black {
  color: black;
}

.underline {
  height: 1px;
  background: black;
}

.total-row-container {
  position: relative;
  top: 35px;
}

.total-content {
  display: flex;
  width: 100%;
  height: 32px;
  flex: 1 0 0;
  border-radius: 20px 20px 20px 20px;
  background: #fafafa;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
}

.client-validation {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 20px 0 0 20px;
  background: #165039;
  color: white;
  min-width: 230px;
}

.repair-content {
  color: white;
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin-left: 10px;
  padding-left: 5px;
  padding-right: 5px;
  border: 1px solid white;
}

.total-price {
  color: black;
  display: flex;
  padding-right: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}

.divider {
  min-height: 10px;
  margin-left: 6px;
}

.active-status {
  background-color: #86c94e;
  color: black;
}

.outdated-status {
  background-color: #efefef;
  color: black;
}

.clickable {
  cursor: pointer;
}

.bold {
  font-weight: bold;
}

.bottom-left-part {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;

  .billing-number {
    margin-left: 10px;
  }
}
</style>
